import { render } from "./MockTest.vue?vue&type=template&id=4e621dc6&scoped=true"
import script from "./MockTest.vue?vue&type=script&lang=js"
export * from "./MockTest.vue?vue&type=script&lang=js"

import "./MockTest.vue?vue&type=style&index=0&id=4e621dc6&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e621dc6"]])

export default __exports__